// extracted by mini-css-extract-plugin
module.exports = {"sign-in":"sign-in_sign-in__9oW72","title":"sign-in_title__2Ezde","buttons":"sign-in_buttons__1VBuF"};